import { brandByExternalId_brandByExternalId_properties } from 'src/app/shared/graphql/types/brandByExternalId';

export function propertySearchFn(term: string, item: brandByExternalId_brandByExternalId_properties)  {
  term = term.toLowerCase();
  return item.name.toLowerCase().indexOf(term) > -1 || item.city?.toLowerCase().indexOf(term) > -1 || item.state?.toLowerCase().indexOf(term) > -1;
}